"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map = void 0;
const JSON_1 = require("./JSON");
function mapObject(object, fn) {
  const acc = {};
  for (let key in object) {
    const value = object[key]; // The ! is because we know the key exists, but typescript doesn't.
    acc[key] = fn(value, key, object);
  }
  return acc;
}
function map(container, fn) {
  if ((0, JSON_1.isObject)(container)) {
    return mapObject(container, fn);
  }
  return container.map(fn);
}
exports.map = map;